import { createFileRoute } from "@tanstack/react-router";

import { LegalList, LegalPage, LegalSection } from "~/components/legal-page";

export const Route = createFileRoute("/confidentialite")({
  component: PrivacyPage,
});

// ⚠️  MODÈLE À FAIRE VALIDER PAR UN CONSEIL JURIDIQUE avant publication.
//     Les mentions entre crochets [ ] doivent être complétées (raison
//     sociale, adresse, numéro CNDP). Ce document décrit fidèlement le
//     traitement réellement effectué par l'application — gardez-le aligné
//     sur le code si les traitements évoluent.
const UPDATED_AT = "9 juillet 2026";

function PrivacyPage() {
  return (
    <LegalPage
      title="Politique de confidentialité"
      updatedAt={UPDATED_AT}
      intro="Gately est un service de gestion des accès pour résidences et resorts. Cette politique explique quelles données personnelles nous traitons, pourquoi, avec qui elles sont partagées et quels sont vos droits. Elle s'applique à l'application mobile Gately et à la console web d'administration."
    >
      <LegalSection n={1} title="Responsable du traitement">
        <p>
          Le responsable du traitement est [Raison sociale de l'éditeur], [forme
          juridique et capital], immatriculée sous le numéro [RC / ICE], dont le
          siège est situé [adresse complète], Maroc (« Gately », « nous »).
        </p>
        <p>
          Contact :{" "}
          <a href="mailto:contact@gately.app" className="text-primary">
            contact@gately.app
          </a>
          . Le traitement est déclaré/autorisé auprès de la CNDP sous la
          référence [numéro CNDP].
        </p>
      </LegalSection>

      <LegalSection n={2} title="Données que nous collectons">
        <p>Nous collectons uniquement les données nécessaires au service :</p>
        <LegalList
          items={[
            <>
              <strong>Numéro de téléphone</strong> — votre identifiant
              principal. Gately n'utilise pas d'adresse e-mail réelle ; une
              adresse technique est générée automatiquement à des fins internes.
            </>,
            <>
              <strong>Nom</strong> et, le cas échéant, une photo de profil que
              vous choisissez d'ajouter.
            </>,
            <>
              <strong>Appartenance à une résidence</strong> — votre unité/foyer,
              votre rôle (résident, propriétaire, concierge/gardien,
              gestionnaire) et les membres de votre foyer que vous ajoutez.
            </>,
            <>
              <strong>Données d'accès</strong> — invitations et laissez-passer
              QR que vous créez ou recevez, ainsi que le journal horodaté des
              entrées/sorties et des scans effectués aux points d'accès.
            </>,
            <>
              <strong>Contenu que vous publiez</strong> — messages, photos ou
              pièces jointes partagés au sein de votre résidence.
            </>,
            <>
              <strong>Jeton de notification push</strong> (identifiant
              d'appareil Expo/APNs/FCM) pour vous envoyer des notifications.
            </>,
            <>
              <strong>Données techniques et de diagnostic</strong> — journaux
              d'erreurs, informations sur l'appareil et l'application, et
              données d'usage agrégées (voir §5).
            </>,
          ]}
        />
        <p>
          Nous ne collectons pas de données bancaires, de géolocalisation
          continue, ni de catégories sensibles (santé, opinions, etc.).
        </p>
      </LegalSection>

      <LegalSection n={3} title="Finalités et bases légales">
        <p>Vos données sont traitées pour les finalités suivantes :</p>
        <LegalList
          items={[
            "Créer et sécuriser votre compte, et vous authentifier par code à usage unique (OTP) — exécution du service.",
            "Gérer les accès de votre résidence : émission, partage et vérification des laissez-passer, tenue du journal d'accès — exécution du service et intérêt légitime de sécurité du site.",
            "Vous envoyer des notifications liées au service (invitations, validations, alertes) — exécution du service.",
            "Assurer la sécurité, prévenir la fraude et diagnostiquer les incidents — intérêt légitime.",
            "Améliorer l'application au moyen de statistiques d'usage — intérêt légitime, dans la limite du strict nécessaire.",
          ]}
        />
        <p>
          Le traitement est effectué conformément à la loi n° 09-08 relative à
          la protection des personnes physiques à l'égard du traitement des
          données à caractère personnel.
        </p>
      </LegalSection>

      <LegalSection n={4} title="Vérification par code (OTP)">
        <p>
          La connexion s'effectue par un code envoyé sur votre numéro de
          téléphone via WhatsApp. À cette fin, votre numéro est transmis à Meta
          Platforms (WhatsApp Business) en qualité de sous-traitant, uniquement
          pour la remise du message. Nous ne partageons aucun autre contenu avec
          WhatsApp.
        </p>
      </LegalSection>

      <LegalSection n={5} title="Prestataires et destinataires">
        <p>
          Nous ne vendons jamais vos données. Elles peuvent être partagées avec
          :
        </p>
        <LegalList
          items={[
            <>
              <strong>Les acteurs de votre résidence</strong> — votre
              gestionnaire (syndic) et les concierges/gardiens ont accès aux
              données d'accès nécessaires à leurs fonctions (identité,
              laissez-passer, journal d'entrées).
            </>,
            <>
              <strong>Hébergement</strong> — nos serveurs sont hébergés chez
              [fournisseur d'hébergement / région].
            </>,
            <>
              <strong>Meta Platforms (WhatsApp)</strong> — remise des codes de
              vérification.
            </>,
            <>
              <strong>DeepSeek</strong> — extraction des informations
              d'invitation (noms, téléphones, e-mails, dates) à partir d'un
              texte collé par un employé dans l'assistant de saisie.
            </>,
            <>
              <strong>Sentry</strong> — suivi des erreurs et des performances
              (instance région Union européenne).
            </>,
            <>
              <strong>PostHog</strong> — statistiques d'usage du produit.
            </>,
            <>
              <strong>Expo, Apple (APNs) et Google (FCM)</strong> — acheminement
              des notifications push.
            </>,
          ]}
        />
        <p>
          Ces prestataires agissent comme sous-traitants et sont tenus de
          protéger vos données. Certains peuvent être situés hors du Maroc ;
          dans ce cas, les transferts sont encadrés par des garanties
          appropriées.
        </p>
      </LegalSection>

      <LegalSection n={6} title="Durée de conservation">
        <p>
          Nous conservons vos données tant que votre compte est actif. Le
          journal d'accès est conservé pendant la durée nécessaire à la sécurité
          de la résidence, puis supprimé ou anonymisé. À la suppression de votre
          compte, vos données personnelles sont effacées ou anonymisées dans un
          délai raisonnable, sous réserve des obligations légales de
          conservation.
        </p>
      </LegalSection>

      <LegalSection n={7} title="Vos droits">
        <p>
          Conformément à la loi 09-08, vous disposez d'un droit d'accès, de
          rectification, d'opposition et de suppression de vos données. Vous
          pouvez également demander la suppression de votre compte directement
          depuis l'application (onglet Compte).
        </p>
        <p>
          Pour exercer ces droits, écrivez à{" "}
          <a href="mailto:contact@gately.app" className="text-primary">
            contact@gately.app
          </a>
          . Vous pouvez aussi saisir la Commission Nationale de contrôle de la
          protection des Données à caractère Personnel (CNDP —{" "}
          <a
            href="https://www.cndp.ma"
            className="text-primary"
            target="_blank"
            rel="noreferrer"
          >
            www.cndp.ma
          </a>
          ).
        </p>
      </LegalSection>

      <LegalSection n={8} title="Sécurité">
        <p>
          Nous mettons en œuvre des mesures techniques et organisationnelles
          appropriées : chiffrement des communications (TLS), stockage sécurisé
          des jetons de session sur l'appareil, contrôle d'accès par rôle. Aucun
          système n'étant infaillible, nous ne pouvons garantir une sécurité
          absolue.
        </p>
      </LegalSection>

      <LegalSection n={9} title="Mineurs">
        <p>
          Gately n'est pas destiné aux enfants de moins de 16 ans. Les comptes
          sont créés à l'invitation d'un gestionnaire de résidence. Si vous
          pensez qu'un mineur nous a communiqué des données sans autorisation,
          contactez-nous pour leur suppression.
        </p>
      </LegalSection>

      <LegalSection n={10} title="Modifications">
        <p>
          Nous pouvons mettre à jour cette politique. En cas de changement
          important, nous vous en informerons dans l'application. La date de
          dernière mise à jour figure en haut de cette page.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
